import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-mute-icon',
  templateUrl: './bmcore-mute-icon.component.html',
  styleUrls: ['./bmcore-mute-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreMuteIconComponent {
  @Input() color = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
